import { useState } from "react";

function CreateServiceForm({ onCreate }: any) {
    const [formData, setFormData] = useState<any>({
        name: '',
        amount: '',
        description: '',
    });

    const handleSubmit = (e: any) => {
        e.preventDefault();
        onCreate(formData);
        setFormData({
            name: '',
            amount: '',
            description: '',
        });
    };

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setFormData((prevState: any) => ({ ...prevState, [name]: value }));
    };

    return (
        <div className="form-container">
            <div className={`form-content show`}>
                <div className="column">
                    <input
                        type="text"
                        name="name"
                        id="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Nombre"
                    />
                </div>
                <div className="column">
                    <input
                        type="number"
                        name="amount"
                        id="amount"
                        value={formData.amount}
                        onChange={handleChange}
                        placeholder="Valor"

                    />
                </div>
                <input
                    type="text"
                    name="description"
                    id="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Descripción"
                />
                <button onClick={handleSubmit}>{'Crear Servicio'}</button>
            </div>
        </div>
    );
}

export default CreateServiceForm;